export var WidgetTypes;
(function (WidgetTypes) {
    WidgetTypes["CONFIGURATOR"] = "configurator";
    WidgetTypes["CHECKOUT"] = "checkout";
    WidgetTypes["MYACCOUNT"] = "myaccount";
    WidgetTypes["FINANCE_CALCULATOR"] = "finance-calculator";
})(WidgetTypes || (WidgetTypes = {}));
//# sourceMappingURL=WidgetTypes.js.map